// extracted by mini-css-extract-plugin
export default {"terms":"Privacy_terms__QIx+Z"};